export default "/profile/images/Bitrix24.svg?7bd6cac5e657ba06a900898af37bd6c7";